var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base-hint",on:{"mouseenter":function($event){_vm.isHintPopupVisible = true},"mouseleave":function($event){_vm.isHintPopupVisible = false},"touch":function($event){_vm.isHintPopupVisible = !_vm.isHintPopupVisible}}},[_vm._v("\n  i\n  "),_c('span',{class:[
      'base-hint-popup',
      { 'base-hint-popup_visible': _vm.isHintPopupVisible }
    ]},[_vm._v("\n    "+_vm._s(_vm.hintText)+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }